import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">为什么选择97影视</h2>
        <p className="section-subtitle">四大核心优势，打造极致追剧体验</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 mx-auto rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="mt-4 text-base font-heading text-foreground-950">{feature.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}